import { render, staticRenderFns } from "./multiselect.vue?vue&type=template&id=71511446&scoped=true"
import script from "./multiselect.vue?vue&type=script&lang=js"
export * from "./multiselect.vue?vue&type=script&lang=js"
import style0 from "./multiselect.vue?vue&type=style&index=0&id=71511446&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71511446",
  null
  
)

export default component.exports